import { gql } from '@apollo/client'

const MutationAddAssetFiles = gql(`
    mutation addAssetFiles($input: [AssetFileInput],  $project: String) {
        addAssetFiles(
            input: $input,
            project: $project
        ) {
            id
            assetId
            mediaId
            # tags
            fileName
            fileSize
            url
            name
            createdAt
            createdBy
            updatedAt
            isArchived
            # category
        }
    }`
)

export default MutationAddAssetFiles
